(function () {
    'use strict';

    angular
        .module('uwAgenda.login')
        .controller('RegistrationController', RegistrationControllerFn);

    /* controller to create new login account */
    RegistrationControllerFn.$inject = ['$sanitize', 'RegistrationService', 'User', 'ContactInfo', 'Alert', '$state', '$localStorage', 'licences', 'countries', 'contactinfotypes'];

    function RegistrationControllerFn($sanitize, RegistrationService, User, ContactInfo, Alert, $state, $localStorage, licences, countries, contactinfotypes) {
        /* jshint validthis:true */
        var vm = this;

        // new account object
        vm.account = {};
        // countries
        vm.countries = [];
        // licences
        vm.licences = [];

        activate();

        /* register new account */
        vm.signUp = function () {          
            // prepare email
            // add email - contact info
            vm.account.contactInfos = [];
            // generate the main contact infos type for email
            contactinfotypes.forEach(function (ctype) {
                if (ctype.type === 3) { // email type
                    // new object
                    var info = new ContactInfo();
                    info.init(ctype);
                    info.sortOrder = 1;
                    info.showInContactDetails = true
                    // add email value
                    info.value = vm.account.email;
                    // add to array
                    vm.account.contactInfos.push(info);
                } // if               
            });

            /// XSS Protect -> sanitize
            vm.account.firstName = $sanitize(vm.account.firstName);
            vm.account.lastName = $sanitize(vm.account.lastName);
            vm.account.email = $sanitize(vm.account.email);
            vm.account.detail.street = $sanitize(vm.account.detail.street);
            vm.account.detail.streetNumber = $sanitize(vm.account.detail.streetNumber);
            vm.account.detail.zipCode = $sanitize(vm.account.detail.zipCode);
            vm.account.detail.location = $sanitize(vm.account.detail.location);
            vm.account.username = $sanitize(vm.account.username);
            vm.account.decryptedPassword = $sanitize(vm.account.password);
            vm.account.rpassword = $sanitize(vm.account.rpassword);


            // make copy
            var user = new User();
            user.extend(vm.account);       

            // prepare final
            user.prepareForSave([]);

            // register
            RegistrationService.register(user).then(function (result) {
                Alert.success('Thank You! Your Account was successfully created');

                // go back to login
                $state.go("Login");
            }, function (error) {
                Alert.warning('Failed to create the new account. Please contact the administrator.');
            });
        };

        /* do activation work */
        function activate() {
            // current language
            var fk_language = $localStorage.CurrentLanguage.id;
            // countries
            vm.countries = countries;
            // licences
            vm.licences = licences;
            // new user object
            vm.account = new User();
            // not confirmed
            vm.account.isConfirmed = false;           
            // new attributes
            vm.account.email = null; // contact info 
            vm.account.agreed = false;
            vm.account.rpassword = null;
        }
    }
})();
